<template>
  <b-overlay
    :show="loading"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
  <div class="measurements-container" v-if="displayMeasurements">
    <div class="popup-content">
      <div class="popup-content-inner">
        <div class="popup-top">
          <div class="points-count">
            <div class="legend">Face Datapoints captured:</div>
            <div class="pt-value">{{pointCloudLineCount}}.</div>
          </div>
          <div class="close-button" @click.prevent="displayMeasurements=!displayMeasurements">
              
                <img width="8" src="/assets/images/arrownew.svg" />

            </div>
            <div class="scan-name">
              <div class="scan-button">
                <div class="initiales">{{ scan.name[0] }}.</div>
                <span class="name">{{ scan.name }}</span>
                <span class="date">{{ scan.date }}</span>
              </div>
            </div>

            <div class="scans-canvas"  >
              <scan-canvas-popup v-if="scan" :scan="scan" />
        
            </div>
          </div>
          <div class="measures-content-inner">
        <div class="measures-big">
          <div class="scan-measures" v-if="measurements">
          
            <div class="title">
              <div class="title-icon"><img src="/assets/images/measures.svg" /></div>
               Morphological Measurements
            </div>

            <template>
              <br />
              
              <span class="label">Cantus Distance:</span> <span class="value">{{ measurements.CantusDistance}}mm</span><br />
            
            <span class="label">Sphenoidal Width :</span> <span class="value">{{ measurements.SpenoidalWidth}}mm</span><br />
            <span class="label">Temple Width:</span> <span class="value">{{ measurements.TempleDistance}}mm</span><br />
            <span class="label">Pantoscopic Angle:</span> <span class="value">{{ measurements.PantoscopicAngle}}°</span><br />
           


            <span class="label">Eyebrow Height :</span> <span class="value">{{ measurements.EyeBrowHeight}}mm</span><br />
            <span class="label">Cheekbone Height :</span> <span class="value">{{ measurements.CheekboneHeight}}mm</span><br />
          
    <!-- 
              Auricular Width : {{ measurements.AuricularWidth}} <br />
              Nasal height : {{ measurements.NasalHeight}}<br />
              Unprojected auricular width :  {{ measurements.UnprojectedAuricularWidth }} -->
            </template>

          
          </div>
        </div>
        <div class="measures-half">
          <div class="measures-small">
            <div class="scan-measures" v-if="measurements">
            
              <div class="title">
                <div class="title-icon"><img src="/assets/images/measures.svg" /></div>
                Optical Measurements
              </div>

              <template>
                <br />
                <span class="label">Eye to lens distance (Topological):</span> <span class="value">{{ measurements.EyeToLensDistance}}mm</span><br />
                <span class="label">Close Pupillary Distance:</span> <span class="value">{{ measurements.PupillaryDistance}}mm</span><br />
                <span class="label">Far Pupillary Distance:</span> <span class="value">{{ measurements.FarPupillaryDistance ? measurements.FarPupillaryDistance : measurements.PupillaryDistance*1+4}}mm</span><br />
          
      <!-- 
                Auricular Width : {{ measurements.AuricularWidth}} <br />
                Nasal height : {{ measurements.NasalHeight}}<br />
                Unprojected auricular width :  {{ measurements.UnprojectedAuricularWidth }} -->
              </template>

            
            </div>
          </div>
          <div class="measures-small">
            <div class="scan-measures" v-if="measurements">
            
              <div class="title">
                <div class="title-icon"><img src="/assets/images/measures.svg" /></div>
                Nasal Measurements
              </div>

              <template>
                <br />
              
                <span class="label">Right Nasal Face Angle :</span> <span class="value">{{ measurements.RightNasalFaceAngle}}°</span>  <br />
                <span class="label">Left Nasal Face Angle :</span> <span class="value">{{ measurements.LeftNasalFaceAngle}}°</span><br />

                
                <span class="label">Right Nasal Caster Angle :</span> <span class="value">{{ measurements.RightNasalCasterAngle}}°</span><br />
                <span class="label">Left Nasal Caster Angle :</span> <span class="value">{{ measurements.LeftNasalCasterAngle}}°</span><br />
    
                <span class="label">Nasal Crete Angle :</span> <span class="value">{{ measurements.NoseCreteAngle}}°</span><br />
                
                <!--
                <span class="label">Nasal Bone Width :</span> <span class="value">{{ measurements.NasalWidth}}mm</span> <br />
               
                <span class="label">Nasal height:</span> <span class="value">{{ measurements.NasalHeight}}mm</span><br />
                -->
                
              </template>

            
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
  <div class="fitting-container">

      <div class="fitting-content">
      <div class="title-line">
        <div class="left">
          <div class="fit-balise good">
 
              <span class="fit-balise-name">
               Complete
              </span>
            </div>

          Face Scan Report
        </div>
        <div class="right">
         
          <div class="right-item" v-if="scan">
            <div class="label">Client</div>
            <div class="value">{{ scan.name }}</div>
          </div>
          <div class="right-item" v-if="scan">
            <div class="label">Scan ID</div>
            <div class="value">#{{ scan.id }}</div>
          </div>
          <div class="right-item" v-if="scan">
            <div class="label">Date of scan</div>
            <div class="value">{{ scan.date }}</div>
          </div>
        </div>
      </div>
     
      
      <div class="scan-content-inner">

      <div class="scan-top" >

        <div class="left-top">
          <div class="scan-name">
            <div class="scan-button">
              <div class="initiales">{{ scan.name[0] }}.</div>
              <span class="name">{{ scan.name }}</span>
              
            </div>
          </div>
          <div class="points-count">
            <div class="legend">Face Datapoints captured:</div>
            <div class="pt-value">{{ pointCloudLineCount }}.</div>
          </div>

          <div class="scans-canvas"  >
            <scan-canvas v-if="scan" :scan="scan" />
       
          </div>
        </div>
        <div class="right-top">
          <div class="scan-measures" v-if="measurements">
          <div>
            <div class="title">
              <div class="title-icon"><img src="/assets/images/measures.svg" /></div>
              Morphological Measurements
            </div>

            
              <br />
            
              <span class="label">Cantus Distance:</span> <span class="value">{{ measurements.CantusDistance}}mm</span><br />
            
              <span class="label">Sphenoidal Width :</span> <span class="value">{{ measurements.SpenoidalWidth}}mm</span><br />
              <span class="label">Temple Width:</span> <span class="value">{{ measurements.TempleDistance}}mm</span><br />
              <span class="label">Pantoscopic Angle:</span> <span class="value">{{ measurements.PantoscopicAngle}}°</span><br />
             


              <span class="label">Eyebrow Height :</span> <span class="value">{{ measurements.EyeBrowHeight}}mm</span><br />
              <span class="label">Cheekbone Height :</span> <span class="value">{{ measurements.CheekboneHeight}}mm</span><br />
            
            
              <br />
            </div>
            <div>
              <div class="title">
              <div class="title-icon"><img src="/assets/images/measures.svg" /></div>
                Optical Measurements
              </div>
              <br />
              <span class="label">Eye to lens distance (Topological):</span> <span class="value">{{ measurements.EyeToLensDistance}}mm</span><br />
              <span class="label">Close Pupillary Distance:</span> <span class="value">{{ measurements.PupillaryDistance}}mm</span><br />
              <span class="label">Far Pupillary Distance:</span> <span class="value">{{ measurements.FarPupillaryDistance ? measurements.FarPupillaryDistance : measurements.PupillaryDistance*1+4}}mm</span><br />
          
    <!-- 
              Auricular Width : {{ measurements.AuricularWidth}} <br />
              Nasal height : {{ measurements.NasalHeight}}<br />
              Unprojected auricular width :  {{ measurements.UnprojectedAuricularWidth }} -->
           
          </div>
           
          </div>
          <div class="measurements-button" @click.prevent="displayMeasurements=!displayMeasurements">
              <span>See more measurements</span>
              <img v-if="!displayMeasurements" width="12" src="/assets/images/plus.svg" />
              <img v-else width="12" src="/assets/images/minusnew.svg" />
             
             
        
          </div>
        </div>
       
      </div>
     <div class="scan-content-details">
      <div class="scan-details" v-if="measurements">
        <div class="scan-detail">
          <div class="detail-title">Pupillary Distance</div>
          <div class="detail-value">{{ (measurements.PupillaryDistance+4).toFixed(3) }} mm</div>
          <div class="jauge">
            <div class="jauge-bg"></div>
            <div class="jauge-bar"  >
            
            </div>
            <div class="jauge-bar-inner" :style="{ width: getPercent(measurements.PupillaryDistance+4, findMin(62,65), findMax(62,65)) + '%' }">
              <div class="bullet"></div>
            </div>
          </div>
          <div class="detail-description">
            Distance between your pupils - ensures accurate prescription lens centration and helps choose the right frame width.<br />
            Compared to the global reference, your pupillary distance sits 
            <template v-if="(measurements.PupillaryDistance+4) + 0.9 >= 62 && (measurements.PupillaryDistance+4) - 0.9 <= 65">
              in the typical range
            </template>
            <template v-else-if="(measurements.PupillaryDistance+4) + 0.9 >= 59.5 && (measurements.PupillaryDistance+4) - 0.9 <= 62">
              in the lower range
            </template>
            <template v-else-if="(measurements.PupillaryDistance+4) + 0.9 > 65 && (measurements.PupillaryDistance+4) - 0.9 <= 67.5">
              in the upper range
            </template>
            <template v-else-if="(measurements.PupillaryDistance+4) + 0.9 < 59.5">
              below reference
            </template>
            <template v-else>
              above reference
            </template>
            .
          </div>
        </div>
        <div class="scan-detail">
          <div class="detail-title">Eye to lens distance</div>
          <div class="detail-value">{{ measurements.EyeToLensDistance }} mm</div>
          <div class="jauge">
            <div class="jauge-bg"></div>
            <div class="jauge-bar">
              
            </div>
            <div class="jauge-bar-inner"  :style="{ width: getPercent(measurements.EyeToLensDistance, findMin(12,14), findMax(12,14)) + '%' }">
                <div class="bullet"></div>
              </div>
          </div>
          <div class="detail-description">
            How close the frame and lenses sit to your eyes — important for comfort and field of view.
<br />
Compared to the global reference, your eye-to-lens distance sits 
            <template v-if="measurements.EyeToLensDistance + 0.9 >= 12 && measurements.EyeToLensDistance - 0.9 <= 14">
              in the typical range
            </template>
            <template v-else-if="measurements.EyeToLensDistance + 0.9 >= 10.5 && measurements.EyeToLensDistance - 0.9 <= 12">
              in the lower range
            </template>
            <template v-else-if="measurements.EyeToLensDistance + 0.9 > 14 && measurements.EyeToLensDistance - 0.9 <= 15.5">
              in the upper range
            </template>
            <template v-else-if="measurements.EyeToLensDistance + 0.9 < 10.5">
              below reference
            </template>
            <template v-else>
              above reference
            </template>
            .
          </div>
        </div>
      </div>

      <div class="scan-details" v-if="measurements">
        <div class="scan-detail">
          <div class="detail-title">Temple width</div>
          <div class="detail-value">{{ measurements.TempleDistance }} mm</div>
          <div class="jauge">
            <div class="jauge-bg"></div>
            <div class="jauge-bar">
              
            </div>
            <div class="jauge-bar-inner" :style="{ width: getPercent(measurements.TempleDistance, findMin(120,140), findMax(120,140)) + '%' }">
              <div class="bullet"></div>
            </div>
          </div>
          <div class="detail-description">
            Width across your temporal bone - a key indicator of face width that helps choose the right frame size.
<br />Compared to the global reference, your temple width sits
            <template v-if="measurements.TempleDistance + 5 >= 120 && measurements.TempleDistance - 5 <= 140">
              in the typical range
            </template>
            <template v-else-if="measurements.TempleDistance + 5 >= 110 && measurements.TempleDistance - 5 <= 120">
              in the lower range
            </template>
            <template v-else-if="measurements.TempleDistance + 5 > 140 && measurements.TempleDistance - 5 <= 145">
              in the upper range
            </template>
            <template v-else-if="measurements.TempleDistance + 5 < 110">
              below reference
            </template>
            <template v-else>
              above reference
            </template>
            .
          </div>
        </div>
        <div class="scan-detail">
          <div class="detail-title">Sphenoidal width</div>
          <div class="detail-value">{{ measurements.SpenoidalWidth }} mm</div>
          <div class="jauge">
            <div class="jauge-bg"></div>
            <div class="jauge-bar">
             
            </div>
            <div class="jauge-bar-inner" :style="{ width: getPercent(measurements.SpenoidalWidth, findMin(115,125), findMax(115,125)) + '%' }">
              <div class="bullet"></div>
            </div>
          </div>
          <div class="detail-description">
            Width across your upper face near the outer eye area — helps predict frame width and overall fit.
            <br />Compared to the global reference, your sphenoidal width sits
            <template v-if="measurements.SpenoidalWidth + 7 >= 115 && measurements.SpenoidalWidth - 7 <= 125">
              in the typical range
            </template>
            <template v-else-if="measurements.SpenoidalWidth + 7 >= 110 && measurements.SpenoidalWidth - 7 <= 115">
              in the lower range
            </template>
            <template v-else-if="measurements.SpenoidalWidth + 7 > 125 && measurements.SpenoidalWidth - 7 <= 135">
              in the upper range
            </template>
            <template v-else-if="measurements.SpenoidalWidth + 7 < 110">
              below reference
            </template>
            <template v-else>
              above reference
            </template>
            .
          </div>
        </div>
      </div>

      <div class="scan-details" v-if="measurements">
        <div class="scan-detail">
          <div class="detail-title">Nose face angle</div>
          <div class="detail-value">{{ ((measurements.LeftNasalFaceAngle+measurements.RightNasalFaceAngle)/2).toFixed(3) }}°</div>
          <div class="jauge">
            <div class="jauge-bg"></div>
            <div class="jauge-bar">
             
            </div>
            <div class="jauge-bar-inner"  :style="{ width: getPercent((measurements.LeftNasalFaceAngle+measurements.RightNasalFaceAngle)/2, findMin(20,25), findMax(20,25)) + '%' }">
              <div class="bullet"></div>
            </div>
          </div>
          <div class="detail-description">
            The vertical slope of your nose where the pads rest. Indicates where pressure tends to concentrate.
<br />
Compared to the global reference, your nose face angle sits 
            <template v-if="(measurements.LeftNasalFaceAngle+measurements.RightNasalFaceAngle)/2 + 1 >= 20 && (measurements.LeftNasalFaceAngle+measurements.RightNasalFaceAngle)/2 - 1 <= 25">
              in the typical range
            </template>
            <template v-else-if="(measurements.LeftNasalFaceAngle+measurements.RightNasalFaceAngle)/2 + 1 >= 15 && (measurements.LeftNasalFaceAngle+measurements.RightNasalFaceAngle)/2 - 1 <= 20">
              in the lower range
            </template>
            <template v-else-if="(measurements.LeftNasalFaceAngle+measurements.RightNasalFaceAngle)/2 + 1 > 25 && (measurements.LeftNasalFaceAngle+measurements.RightNasalFaceAngle)/2 - 1 <= 30">
              in the upper range
            </template>
            <template v-else-if="(measurements.LeftNasalFaceAngle+measurements.RightNasalFaceAngle)/2 + 1 < 15">
              below reference
            </template>
            <template v-else>
              above reference
            </template>
            .  
          </div>
        </div>
        <div class="scan-detail">
          <div class="detail-title">Nose caster angle</div>
          <div class="detail-value">{{ ((measurements.LeftNasalCasterAngle+measurements.RightNasalCasterAngle)/2).toFixed(3) }}°</div>
          <div class="jauge">
            <div class="jauge-bg"></div>
            <div class="jauge-bar">
              
            </div>
            <div class="jauge-bar-inner"  :style="{ width: getPercent((measurements.LeftNasalCasterAngle+measurements.RightNasalCasterAngle)/2, findMin(20,25), findMax(20,25)) + '%' }">
              <div class="bullet"></div>
            </div>
          </div>
          <div class="detail-description">
            The front-to-back slope where the nose pads sit — helps predict how balanced the frame feels on your nose.
<br />Compared to the global reference, your nose caster angle sits
            <template v-if="(measurements.LeftNasalCasterAngle+measurements.RightNasalCasterAngle)/2 + 1 >= 20 && (measurements.LeftNasalCasterAngle+measurements.RightNasalCasterAngle)/2 - 1 <= 25">
              in the typical range
            </template>
            <template v-else-if="(measurements.LeftNasalCasterAngle+measurements.RightNasalCasterAngle)/2 + 1 >= 15 && (measurements.LeftNasalCasterAngle+measurements.RightNasalCasterAngle)/2 - 1 <= 20">
              in the lower range
            </template>
            <template v-else-if="(measurements.LeftNasalCasterAngle+measurements.RightNasalCasterAngle)/2 + 1 > 25 && (measurements.LeftNasalCasterAngle+measurements.RightNasalCasterAngle)/2 - 1 <= 30">
              in the upper range
            </template>
            <template v-else-if="(measurements.LeftNasalCasterAngle+measurements.RightNasalCasterAngle)/2 + 1 < 15">
              below reference
            </template>
            <template v-else>
              above reference
            </template>
            .  
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>
    </div>
  </b-overlay>
</template>

<script>

import {BModal, BButton,BOverlay, VBModal, BRow, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest, Woocommerce} from '@simb2s/senseye-sdk'

import { VueGoodTable } from 'vue-good-table'
import ScanPopup from '../../components/ScanPopup.vue'
import PrescriptionPopup from '../../components/PrescriptionPopup.vue'

import ScanCanvas from './ScanCanvas2.vue'
import ScanCanvasPopup from './ScanCanvasPopup.vue'
import ScanViewer from './ScanViewer.vue'
import html2pdf from "html2pdf.js";

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BOverlay,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    BRow,
    ScanPopup,
    PrescriptionPopup,
    ScanCanvas,
    ScanCanvasPopup,
    ScanViewer
  },
  data() {
    return {
      scan:null,
      selectedScan:localStorage.senseye_b2b_selected_scan,
      loading:true,
      pointCloudLineCount: null,
      displayMeasurements:false,
      measurements:null
    }
  },
  
  methods:{
    getPercent(value, min, max) {
      let percent = ((value - min) / (max - min)) * 100
      return Math.max(0, Math.min(100, percent))
    },
    findMin(v33, v66) {
      const range = (v66 - v33) / 0.2
      const min = v33 - 0.4 * range
     

      return min
    },
    findMax(v33, v66) {
      const range = (v66 - v33) / 0.2
      const min = v33 - 0.4 * range
      const max = min + range

      return max 
    },
    generateReport () {
      html2pdf(document.getElementById("element-to-convert"), {
        margin: 0,
        
        filename: "generated-pdf.pdf",
      });
    },
    async getScan() {
      let scan=await APIRequest.detail('scans',this.$route.params.id)
      this.scan={}
      this.scan=scan

      if(scan.measurements)
      {
        let measurements=scan.measurements.replace('."',',"')
        measurements=measurements.replace('."',',"')
        measurements=measurements.replace('."',',"')
        measurements=measurements.replace('."',',"')
        
    
        this.measurements=JSON.parse(measurements)
      }

      let pointCloud=await APIRequest.get_request('api/scans/point-cloud/'+this.scan.id)
 
      if (pointCloud.data.pointCloud) {
        try {
          const text = pointCloud.data.pointCloud
        
          // filter(Boolean) removes empty last line if file ends with \n
          this.pointCloudLineCount = text.split('\n').filter(Boolean).length
       
        } catch (e) {
          console.error('Error fetching point cloud file', e)
        }
      }

      
      //import data from "/Users/Documents/workspace/test.json"
    },
    selectScan(id) {
      this.selectedScan=this.scan.id
      localStorage.senseye_b2b_selected_scan=this.scan.id
   
    },
    
    
  },
  watch:{
    
  },
  async mounted()
  {
    if(this.$route.params.token)
    {
      localStorage.token_senseye_auth=this.$route.params.token
    }
    this.loading=true
    
    await this.getScan()
    this.loading=false
  }
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
.points-count .legend 
{
  color:#999;
}
.jauge-bg
{
  z-index: 2;
  position: absolute;
  background-image:url('/assets/images/bgjauge.png');
  background-size:20% 100%;
  background-position: center top;
  background-repeat: no-repeat;
  width:100%;
  height:100%;
  left:0;
  top:0;
}
.jauge
{
  position: relative;
  width:100%;
  padding-top:8px;
  padding-bottom:8px;
 
  margin-bottom:20px;
}
.detail-description 
{
  border-radius: 5px;
  padding:10px;
  background:#f1f1f1;
 
  color:#999;
}
.jauge-bar-inner .bullet
{
  position: absolute;
  top:-5px;
  right:0px;
  transform: translateX(50%);
  width:15px;
  height:15px;
  background:#10C05F;
  border-radius: 50%;
}
.jauge-bar-inner
{
  z-index:3;
  position: absolute;
  top:50%;
  transform: translateY(-50%);
  left:0px;
  height:5px;
  background:#10C05F;
  border-radius: 5px;
}
.jauge-bar
{
  z-index: 1;
  position: relative;
  width:100%;
  height:5px;
  background:#f1f1f1;
  border-radius: 5px;
}
.detail-value
{
  position: absolute;
  top:0px;
  right:0px;
  color:#999;
}
.detail-title
{
  font-size:15px;
  
  margin-bottom:10px;
}
.scan-detail
{
  position: relative;
  width:50%;
}
.scan-details
{
  display:flex;
  flex-direction: row;
  justify-content: space-between;

  width:100%;
  gap:20px;
  margin-top:20px;
}
.measurements-button
  {
    position:absolute;
    
    bottom:20px;
    right:20px;
   
    display:flex;
    background:#f1f1f1;
    font-size:12px;
    cursor:pointer;
    padding:5px 10px;
    border-radius: 5px;
    align-items:center;
    justify-content:center;
    gap:10px;
  }
.subtitle
{
  padding:8px 15px;
  font-size:12px;
  width:fit-content;
  margin-top:10px;
  margin-bottom:10px;
  background:#63ff2b;
  border-radius: 5px;
}
.left-top
{
  width: 55%;
  position: relative;
}
.right-top
{
  width: 45%;
  position: relative;
  background:#fff;
  padding:20px;
  border-radius: 5px;
}
.scan-top 

{
  background:#f1f1f1;
  padding:20px;
  border-radius: 5px;
  display:flex;
  gap:20px;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  width:100%;
}
.date
{
  color:#999;
  margin-left:40px;
  margin-right:20px;
}
.scan-button
{
  display:flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap:15px;
  background:#f1f1f1;
  padding:5px;
  border-radius: 5px;
}
.initiales
{
  background:#fff;
  padding:5px 12px;
  color:#999;
  border-radius: 5px;
}
.scan-name
{
  display:flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color:#000;
  z-index: 2;
  font-size:14px;

  position: absolute;
  top:0px;
  left:0px;
}
.label
{
  color:#999;
  font-size:12px;
}
.value
{
  float:right;
  color:#000;
  font-size:12px;
}
.title-line .left .fit-balise
{
  font-size:12px;
  margin-bottom: 0 !important;
}
.title-line .left
{
  font-size:40px;
}
.fitting-content
{
  display:flex;
  max-width:964px;
  flex-direction: column;
  width:80%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 50px;
}
.title-line .right
{
  display:flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap:20px;
}
.title-line .right-item
{
  display:flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

}
.title-line
{
  color:#000;
  display:flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  width:100%;
  margin-bottom:20px;
}
.scan-measures .title 
{
  margin-bottom:0px;
  font-size:14px;
  display:flex;

  align-items: center;
  justify-content: flex-start;
  gap:10px;
}
.fit-balise.good 
{
  background:#DBF6E7;
  color:#10C05F;
}
.fit-balise 
{
  margin-bottom:0px;
  width:fit-content;
  display:flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap:10px;
  padding:9px 10px;
  border-radius: 5px;
}
.fitting-container
{
  font-weight:400;
  font-family:"degular";
  color:#000;
  font-size:12px;
 background-color: #fff;
 min-height:100vh;
 padding-bottom:50px;
}
.scan-measures
{
  position:relative;
  color:#000;
  font-size:12px;

}
.popup-top .points-count
{

  text-align:right;
  position:absolute;
  left:auto;
  right:20px;
  bottom:auto;
  top:20px;
  z-index:5;

}
.points-count
{
  text-align:left;
  position:absolute;
  left:0px;
  bottom:0px;
  z-index:5;
}
.scans-canvas
{
  display:flex;
  width:100%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height:100%;
}
#app 
{
  background-color: #fff;
}
.overlay-scan {
  width:100%;
  height:100vh;
  z-index:999999;
}
#element-to-convert
{
  
 
  margin-left: auto;
  margin-right: auto;
}
.title-icon img 
{
  height:15px;
}
.popup-content-inner .title-icon
{
  background:#fff;
}
.title-icon
{
  width:30px;
  height:30px;
  border-radius: 5px;
  background:#f1f1f1;
  display:flex;
  align-items: center;
  justify-content: center;
}
.popup-top .scan-name
{
  position: absolute;
  bottom:20px;
  width:calc(100% - 40px);
 display:block;
top:auto;
  left:20px;
}
.popup-top .initiales
{
  background:#f1f1f1;
}
.popup-top .scan-button 
{
  justify-content: flex-start;
  background:#fff;
}
.popup-content-inner
{
  position: relative;
  width:100%;
  height:100%;
  padding:20px;
  position:relative;
  background:#fff;
  border-radius: 5px;
}
.popup-content
{
  max-width:964px;
  margin-left: auto;
  margin-right: auto;
  width:80%;
  padding:20px;
}
.popup-top
{
  position: relative;
  
}
.measurements-container 
{
  position:fixed;
  top:0;
  left:0;
  overflow-y: auto;
  height:100vh;
  width:100%;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.1);
  z-index: 999999;

  
}
.close-button img
{
  transform: rotate(180deg);
}
.close-button
{
  position:absolute;
  top:20px;
  left:20px;
  cursor:pointer;
  background:#fff;
  border-radius: 5px;
  z-index:5;
  width:32px;
  height:32px;
  display:flex;
  align-items: center;
  justify-content: center;
}
.measures-half
{
  display:flex;
  gap:20px;
  justify-content: space-between;
  margin-top:20px;
}
.measures-small
{
  background:#f1f1f1;
  padding:20px;
  width:50%;
  border-radius: 5px;
  
}
.measures-big
{
  background:#f1f1f1;
  padding:20px;
  border-radius: 5px;
  margin-top:20px;
}
@media (orientation: landscape) {
  .fitting-content
  {
    width:90% !important;
    max-width: 2000px !important;
  }
  .scan-content-inner
  {
    align-items: center;
    display:flex;
  }
  .scan-content-details
  {
    padding-left:20px;
  }
  .scan-top
  {
    flex-direction: column;
  }
  .left-top
  {
    width:100% !important;
  }
  .right-top
  {
    width:100% !important;
  }
  .right-top .scan-measures
  {
    display:flex;
    gap:20px;
    justify-content: space-between;
  }
  .right-top .scan-measures > div 
  {
    
    width:50% !important;
  }
  .popup-content
  {
    width:90% !important;
    max-width: 2000px !important;
  }
  .popup-content-inner

  {
    display:flex;
  }
  
  .popup-top
  {
    width:50% !important;
  }
  .measures-content-inner
  {
    padding-left:20px;
    width:50% !important;
  }
  .measures-half
  {
    flex-direction: column;
  }
  .measures-big
  {
    margin-top:0px !important;
  }
  .measures-small
  {
    width:100% !important;
  }
 
}
</style>
